<template>
  <v-container>
    <ValidationObserver ref="obs">
      <div style="text-align: center">
        <h1 class="blue--text mt-5">فرم ثبت نام خریدار</h1>
      </div>
      <v-form v-if="true" class="pa-1 pa-md-4 my-4" ref="form">
        <div class="d-flex flex-column justify-start align-start">
          <v-row>
            <v-col cols="12" v-if="!form.creatorIsManager">
              <h4 class="mb-0 fieldset-title">مشخصات ثبت نام کننده</h4>
            </v-col>
            <v-col cols="12">
              <v-checkbox
                hide-details
                class="mt-0 mb-2"
                v-model="form.creatorIsManager"
              >
                <template v-slot:label>
                  <div>ثبت نام کننده، مدیر کسب و کار نیز هست</div>
                  <HelperComponent helperId="how-register-first-step" />
                </template>
              </v-checkbox>
            </v-col>
            <transition name="fade">
              <v-col v-if="!form.creatorIsManager" cols="12">
                <v-row class="px-md-2">
                  <v-col cols="12" sm="6">
                    <ValidationProvider
                      vid="creatorFirstName"
                      name="نام ثبت نام کننده"
                      rules="required"
                    >
                      <v-text-field
                        slot-scope="{ errors }"
                        :error-messages="errors"
                        type="text"
                        label="* نام "
                        outlined
                        dense
                        v-model="form.creatorPerson.firstName"
                      />
                    </ValidationProvider>
                  </v-col>
                  <v-col cols="12" sm="6">
                    <ValidationProvider
                      vid="creatorLastName"
                      name="نام خانوادگی ثبت نام کننده"
                      rules="required"
                    >
                      <v-text-field
                        slot-scope="{ errors }"
                        :error-messages="errors"
                        v-model="form.creatorPerson.lastName"
                        type="text"
                        label="* نام خانوادگی "
                        outlined
                        dense
                      />
                    </ValidationProvider>
                  </v-col>

                  <v-col cols="12" sm="6">
                    <ValidationProvider
                      name="نقش ثبت نام کننده"
                      rules="required"
                    >
                      <v-select
                        slot-scope="{ errors }"
                        :error-messages="errors"
                        :disabled="freezer"
                        v-model="form.creatorPerson.memberType"
                        outlined
                        label="* نقش"
                        item-text="displayName"
                        item-value="title"
                        dense
                        required
                        :items="filteredMerchantMemberTypeItems"
                      />
                    </ValidationProvider>
                  </v-col>
                  <v-col cols="12" md="6">
                    <div>
                      <ValidationProvider
                        vid="creatorBirthDate"
                        name="تاریخ تولد ثبت نام کننده"
                        rules=""
                      >
                        <date-picker
                          v-model="form.creatorPerson.birthdate"
                          format="YYYY-MM-DD"
                          display-format="jYYYY-jMM-jDD"
                          ref="reserveDateUtc"
                          :clearable="true"
                          :max="subYearsOfDate(16)"
                          :initial-value="subYearsOfDate(17)"
                          simple
                          label="تاریخ تولد"
                        ></date-picker>
                      </ValidationProvider>
                    </div>
                  </v-col>
                  <v-col cols="12" sm="6">
                    <div class="required">* کد ملی</div>
                    <v-text-field
                      required
                      :disabled="freezer"
                      v-model="form.creatorPerson.nationalCode"
                      outlined
                      type="number"
                      dense
                      :rules="[
                        (v) =>
                          !v ||
                          /^(\d{10,10})+$/.test(v) ||
                          'کد ملی حتما باید عدد و 10 رقم باشد',
                        ,
                        (v &&
                          validationErr != null &&
                          validationErr.propertyName ==
                            'CreatorPerson.NationalCode' &&
                          validationErr.errorMessage) ||
                          (validationErr && validationErr.errorMessage),
                      ]"
                      maxlength="10"
                      counter
                      oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);"
                      @keypress="nationalCodeValidationErr()"
                    />
                  </v-col>

                  <v-col cols="12" md="4">
                    <div class="mr-md-6">
                      <ValidationProvider
                        name="جنسیت ثبت نام کننده"
                        vid="creatorGender"
                        rules="required"
                      >
                        <v-radio-group
                          slot-scope="{ errors }"
                          :error-messages="errors"
                          :disabled="freezer"
                          v-model="form.creatorPerson.gender"
                          label="* جنسیت"
                          class="mt-0"
                          row
                        >
                          <v-radio
                            class=""
                            label="زن"
                            value="Female"
                            style="margin-right: 0"
                          ></v-radio>
                          <v-radio
                            class=""
                            label="مرد"
                            value="Male"
                            style="margin-right: 0"
                          ></v-radio>
                        </v-radio-group>
                      </ValidationProvider>
                    </div>
                  </v-col>
                </v-row>
              </v-col>
            </transition>
          </v-row>
        </div>
        <div class="d-flex flex-column justify-start align-start mt-6">
          <v-row class="w--100">
            <v-col cols="12">
              <h4 class="mb-2 fieldset-title">
                اطلاعات صاحب کارگاه/کسب و کار/مدیر عامل
              </h4>
            </v-col>
            <v-col cols="12" sm="6">
              <ValidationProvider
                vid="managerFirstName"
                name="نام"
                rules="required"
              >
                <v-text-field
                  slot-scope="{ errors }"
                  :error-messages="errors"
                  :disabled="freezer"
                  v-model="form.managerPerson.firstName"
                  type="text"
                  label="* نام"
                  outlined
                  dense
                />
              </ValidationProvider>
            </v-col>
            <v-col cols="12" sm="6">
              <ValidationProvider
                vid="managerLastName"
                name="نام خانوادگی"
                rules="required"
              >
                <v-text-field
                  slot-scope="{ errors }"
                  :error-messages="errors"
                  :disabled="freezer"
                  v-model="form.managerPerson.lastName"
                  type="text"
                  label="* نام خانوادگی"
                  outlined
                  dense
                />
              </ValidationProvider>
            </v-col>

            <v-col cols="12" md="4">
              <div class="required">* تاریخ تولد</div>
              <div>
                <ValidationProvider
                  name="تاریخ تولد "
                  vid="managerBirthDate"
                  rules=""
                >
                  <date-picker
                    :clearable="true"
                    v-model="form.managerPerson.birthdate"
                    format="YYYY-MM-DD"
                    display-format="jYYYY-jMM-jDD"
                    ref="reserveDateUtc"
                    :max="subYearsOfDate(16)"
                    :initial-value="subYearsOfDate(17)"
                    simple
                  ></date-picker>
                </ValidationProvider>
              </div>
            </v-col>

            <v-col cols="12" sm="4">
              <div class="required">* کد ملی</div>
              <v-text-field
                required
                :disabled="freezer"
                v-model="form.managerPerson.nationalCode"
                outlined
                type="number"
                dense
                :rules="[
                  (v) =>
                    !v ||
                    /^(\d{10,10})+$/.test(v) ||
                    'کد ملی حتما باید عدد و 10 رقم باشد',
                  ,
                  (v &&
                    validationErr != null &&
                    validationErr.propertyName ==
                      'ManagerPerson.NationalCode' &&
                    validationErr.errorMessage) ||
                    (validationErr && validationErr.errorMessage),
                ]"
                maxlength="10"
                counter
                oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);"
                @keypress="nationalCodeValidationErr()"
              />
            </v-col>
            <v-col cols="12" sm="4">
              <div class="required">شماره موبایل</div>

              <ValidationProvider
                name="شماره موبایل"
                vid="mobile"
                rules="required"
              >
                <v-text-field
                  :disabled="freezer"
                  v-model="form.managerPerson.mobile"
                  outlined
                  type="number"
                  dense
                />
              </ValidationProvider>
            </v-col>
            <v-col cols="12" md="4">
              <div class="mr-md-6">
                <ValidationProvider
                  name="جنسیت"
                  vid="managerGender"
                  rules="required"
                >
                  <v-radio-group
                    slot-scope="{ errors }"
                    :error-messages="errors"
                    :disabled="freezer"
                    v-model="form.managerPerson.gender"
                    label="* جنسیت"
                    class="mt-0"
                    row
                  >
                    <v-radio
                      class=""
                      label="زن"
                      value="Female"
                      style="margin-right: 0"
                    ></v-radio>
                    <v-radio
                      class=""
                      label="مرد"
                      value="Male"
                      style="margin-right: 0"
                    ></v-radio>
                  </v-radio-group>
                </ValidationProvider>
              </div>
            </v-col>
          </v-row>
        </div>
        <div class="d-flex flex-column justify-start align-start my-8">
          <v-row class="w--100">
            <v-col cols="12">
              <h4 class="mb-2 fieldset-title">مشخصات خریدار</h4>
            </v-col>
            <v-col cols="12" class="mb-3">
              <p>نوع کسب و کار</p>
              <v-radio-group
                hide-details
                :disabled="freezer"
                v-model="formType"
                row
                @change="changeFormType()"
              >
                <v-radio
                  style="margin-right: 0; margin-left: 16px"
                  v-for="companyType in companyTypeGroups"
                  :key="companyType.id"
                  :label="companyType.title"
                  :value="companyType.id"
                ></v-radio>
              </v-radio-group>
            </v-col>

            <v-col cols="12" class="mb-3">
              <v-sheet shaped outlined class="pa-1 pa-md-7">
                <v-container>
                  <v-row>
                    <v-col v-if="formType == '1'" cols="12" sm="6">
                      <ValidationProvider name="نام شرکت" rules="required">
                        <v-text-field
                          slot-scope="{ errors }"
                          :error-messages="
                            companyNameErrors.length
                              ? companyNameErrors
                              : errors
                          "
                          @blur="checkValidName($event, 'نام شرکت')"
                          label="* نام شرکت"
                          :disabled="freezer"
                          v-model="form.company.name"
                          type="text"
                          outlined
                          dense
                        />
                      </ValidationProvider>
                    </v-col>

                    <v-col
                      cols="12"
                      sm="6"
                      v-if="formType == '2' || formType == '3'"
                    >
                      <ValidationProvider
                        name="نام کارگاه/کسب وکار"
                        rules="required"
                      >
                        <v-text-field
                          slot-scope="{ errors }"
                          :error-messages="
                            companyNameErrors.length
                              ? companyNameErrors
                              : errors
                          "
                          @blur="checkValidName($event, 'نام کارگاه/کسب وکار')"
                          label="* نام کارگاه/کسب وکار"
                          :disabled="freezer"
                          v-model="form.name"
                          type="text"
                          outlined
                          dense
                        />
                      </ValidationProvider>
                    </v-col>
                    <v-col cols="12" sm="6" v-if="formType == '2'">
                      <ValidationProvider name="کد ایسیک" rules="min:6|max:12">
                        <v-text-field
                          label="کد ایسیک"
                          slot-scope="{ errors }"
                          :error-messages="errors"
                          :disabled="freezer"
                          v-model="form.company.isic"
                          type="number"
                          outlined
                          dense
                        />
                      </ValidationProvider>
                    </v-col>
                    <v-col cols="12" sm="6" v-if="formType == '2'">
                      <v-text-field
                        label="شناسه صنفی"
                        :disabled="freezer"
                        v-model="form.company.guildId"
                        type="number"
                        outlined
                        dense
                      />
                    </v-col>
                    <v-col cols="12" sm="6" v-if="formType == '1'">
                      <ValidationProvider name="شناسه ملی" rules="required">
                        <v-text-field
                          slot-scope="{ errors }"
                          :error-messages="errors"
                          label="*  شناسه ملی"
                          :disabled="freezer"
                          v-model="form.company.nationalId"
                          type="number"
                          outlined
                          dense
                        />
                      </ValidationProvider>
                    </v-col>

                    <v-col cols="12" sm="6" v-if="formType == '1'">
                      <ValidationProvider name="شماره ثبت" rules="required">
                        <v-text-field
                          slot-scope="{ errors }"
                          :error-messages="errors"
                          label="* شماره ثبت"
                          :disabled="freezer"
                          v-model="form.company.registrarNumber"
                          type="number"
                          outlined
                          dense
                        />
                      </ValidationProvider>
                    </v-col>
                    <v-col cols="12" sm="6">
                      <ValidationProvider name="نوع ثبت" rules="required">
                        <v-select
                          slot-scope="{ errors }"
                          :error-messages="errors"
                          label="* نوع ثبت"
                          :disabled="freezer"
                          v-model="form.company.companyType"
                          outlined
                          item-text="companyTypeTitle"
                          item-value="companyType"
                          dense
                          required
                          :items="registerTypeList"
                        />
                      </ValidationProvider>
                    </v-col>
                    <v-col cols="12" sm="6">
                      <ValidationProvider
                        name="سال تاسیس"
                        rules="min_value:1250|max_value:1402"
                      >
                        <v-text-field
                          slot-scope="{ errors }"
                          :error-messages="errors"
                          label="سال تاسیس"
                          :disabled="freezer"
                          v-model="form.yearOfFoundation"
                          type="number"
                          outlined
                          dense
                        />
                      </ValidationProvider>
                    </v-col>
                    <v-col cols="12" sm="6">
                      <ValidationProvider
                        name="تعداد کارکنان"
                        rules="min_value:1"
                      >
                        <v-text-field
                          slot-scope="{ errors }"
                          :error-messages="errors"
                          label="تعداد کارکنان"
                          :disabled="freezer"
                          v-model="form.numberOfEmployee"
                          type="number"
                          outlined
                          dense
                        />
                      </ValidationProvider>
                    </v-col>
                  </v-row>
                </v-container>
              </v-sheet>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" md="6">
              <ValidationProvider name="تلفن دفتر" rules="required">
                <v-text-field
                  slot-scope="{ errors }"
                  :error-messages="errors"
                  label="تلفن دفتر کار"
                  v-model="form.phones[0].phoneNumber"
                  :disabled="freezer"
                  type="number"
                  outlined
                  dense
                />
              </ValidationProvider>
            </v-col>
            <v-col cols="12" md="6">
              <ValidationProvider name="تلفن همراه" rules="required">
                <v-text-field
                  slot-scope="{ errors }"
                  :error-messages="errors"
                  label="تلفن همراه"
                  v-model="form.phones[1].phoneNumber"
                  :disabled="freezer"
                  type="number"
                  outlined
                  dense
                />
              </ValidationProvider>
            </v-col>

            <v-col cols="12" md="6">
              <v-autocomplete
                label="افزودن شماره تماس‌های بیشتر"
                :items="phoneTypeItems"
                item-text="displayName"
                item-value="title"
                v-model="selectedPhoneTypes"
                multiple
                dense
                outlined
                append-icon="$close"
              >
              </v-autocomplete>
            </v-col>

            <!-- <v-col cols="12">
              <v-row
                class="px-2"
                v-if="selectedPhoneTypes && selectedPhoneTypes.length"
              >
                <v-col
                  v-for="(item, index) in form.phones"
                  :key="index"
                  cols="12"
                  md="6"
                >
                  <ValidationProvider
                    name='' + item.title
                    rules="required"
                     
                  >
                    <v-text-field
                      slot-scope="{ errors }"
                      :error-messages="errors"
                      :label="'*  شماره ' + item.title"
                      placeholder="َشماره تلفن وارد کنید"
                      :disabled="freezer"
                      v-model="form.phones[index].phoneNumber"
                      type="number"
                      outlined
                      dense
                      @click:prepend-inner="removePhoneType(item)"
                      prepend-inner-icon="mdi-trash-can"
                    />
                  </ValidationProvider>
                </v-col>
              </v-row>
            </v-col> -->
            <v-col cols="12">
              <v-col cols="12" md="6">
                <ValidationProvider name="ایمیل" rules="email">
                  <v-text-field
                    slot-scope="{ errors }"
                    :error-messages="errors"
                    label="ایمیل"
                    v-model="form.email"
                    :disabled="freezer"
                    outlined
                    dense
                  />
                </ValidationProvider>
              </v-col>
              <v-col cols="12" md="6"></v-col>
            </v-col>
            <v-col cols="12" md="4">
              <v-select
                label="استان"
                :disabled="freezer"
                v-model="stateId"
                outlined
                item-text="value"
                item-value="id"
                dense
                :items="provinceList"
                @change="getCitys()"
              />
            </v-col>
            <v-col cols="12" md="4">
              <ValidationProvider name="شهرستان" rules="required">
                <v-select
                  slot-scope="{ errors }"
                  :error-messages="errors"
                  label="* شهرستان"
                  :disabled="freezer"
                  hint="ابتدا استان خود را انتخاب کنید"
                  persistent-hint
                  v-model="cityId"
                  outlined
                  item-text="value"
                  item-value="id"
                  dense
                  :items="cityList"
                  @change="getUrbanareasByCity()"
                />
              </ValidationProvider>
            </v-col>

            <v-col cols="12" md="4">
              <v-select
                :items="industrialParksItems"
                item-text="name"
                item-value="id"
                v-model="form.address.industrialParkId"
                :disabled="cityId == ''"
                dense
                outlined
                label="شهرک صنعتی"
                placeholder="ابتدا استان و شهرستان را انتخاب کنید"
              >
              </v-select>
            </v-col>
            <v-col cols="12">
              <ValidationProvider name="آدرس" rules="required|min:3|max:500">
                <v-text-field
                  slot-scope="{ errors }"
                  :error-messages="errors"
                  label="* اطلاعات تکمیلی آدرس"
                  placeholder="محله، خیابان و کوچه"
                  :disabled="freezer"
                  v-model="form.address.addressLane"
                  type="text"
                  outlined
                  dense
                />
              </ValidationProvider>
            </v-col>
            <v-col cols="12" md="4">
              <ValidationProvider name="شماره پلاک" rules="required|numeric">
                <v-text-field
                  slot-scope="{ errors }"
                  :error-messages="errors"
                  label="* پلاک"
                  :disabled="freezer"
                  v-model="form.address.no"
                  type="number"
                  outlined
                  dense
                />
              </ValidationProvider>
            </v-col>
            <v-col cols="12" md="4">
              <v-text-field
                label="واحد"
                :disabled="freezer"
                v-model="form.address.unit"
                type="number"
                outlined
                dense
              />
            </v-col>
            <v-col cols="12" md="4">
              <ValidationProvider name="کد پستی" rules="required|postalCode">
                <v-text-field
                  slot-scope="{ errors }"
                  :error-messages="errors"
                  label="* کد پستی"
                  :disabled="freezer"
                  v-model="form.address.postalCode"
                  type="number"
                  outlined
                  dense
                />
              </ValidationProvider>
            </v-col>

            <v-col cols="12">
              <div class="text-secondary">موقعیت جغرافیایی (اختیاری)</div>
              <v-col md="6" sm="12">
                <v-autocomplete
                  v-model.lazy="mapSearchValue"
                  :items="mapSearchItems"
                  :loading="mapSearchLoading"
                  :search-input.sync="handleMapSearch"
                  outlined
                  item-text="title"
                  return-object
                  prepend-inner-icon="mdi-map-marker"
                  label="جستــجو"
                  hide-no-data
                  placeholder="مکان مورد نظر خود را وارد کنید"
                >
                  <template v-slot:item="data">
                    <v-list-item-content>
                      <v-list-item-title
                        v-html="data.item.title"
                      ></v-list-item-title>
                      <v-list-item-subtitle
                        v-html="data.item.region"
                      ></v-list-item-subtitle>
                      <v-list-item-subtitle
                        v-html="data.item.address"
                      ></v-list-item-subtitle>
                    </v-list-item-content>
                  </template>
                </v-autocomplete>
              </v-col>
              <l-map
                ref="myMap"
                :zoom="zoom"
                :center="center"
                style="width: 100%; height: 300px"
                @click="addMarkerAddr"
                @fullscreenchange="handleFullScreenChange"
                @update:center="centerUpdated"
              >
                <l-control-fullscreen
                  position="topleft"
                  :options="{
                    title: { false: 'Go big!', true: 'Be regular' },
                  }"
                />
                <l-tile-layer :url="url" />
                <l-marker
                  v-for="(item, index) in marker"
                  :key="index"
                  :lat-lng="item"
                >
                  <l-icon
                    :icon-size="[40, 40]"
                    :icon-anchor="[20, 40]"
                    :icon-url="path"
                  >
                  </l-icon>
                </l-marker>
              </l-map>
              <v-btn
                @click="currentLocationButton"
                id="currentLocationButton"
                color="info"
                fab
                small
                dark
              >
                <v-icon>mdi-crosshairs-gps</v-icon>
              </v-btn>
              <v-btn
                @click="goToMarkPlace"
                id="refreshButton"
                color="primary"
                fab
                small
                dark
              >
                <v-icon>mdi-map-marker-question </v-icon>
              </v-btn>
            </v-col>
          </v-row>
        </div>
        <v-row>
          <v-col class="d-flex justify-end mb-8" cols="12">
            <slot></slot>
          </v-col>
        </v-row>
      </v-form>
    </ValidationObserver>
  </v-container>
</template>

<script>
import { RepoFactory } from '@/baseRepository/Factory';
import Helper from '@/core/helpers';
const merchantRepository = () => RepoFactory.get('merchant');
const urbanAreasRepository = () => RepoFactory.get('urbanAreas');
const enumsRepository = () => RepoFactory.get('enums');
const supplierProductRepository = () => RepoFactory.get('supplierProduct');
const industrialParksRepository = () => RepoFactory.get('industrialParks');
const categoryRepository = () => RepoFactory.get('category');
import VuePersianDatetimePicker from 'vue-persian-datetime-picker';
import { mapGetters } from 'vuex';
import Multiselect from 'vue-multiselect';
import reusableMethodsMixin from '@/core/mixins/reusableMethodsMixin';
import asyncLoadMixin from '@/core/mixins/asyncLoadMixin';

export default {
  name: 'registrationForm',
  props: {
    validationErr: {
      type: Object,
      default: {
        propertyName: '',
        errorMessage: '',
      },
    },
    formData: {
      type: Object,
      default: () => ({}),
    },
    freezer: {
      type: Boolean,
      default: false,
    },
  },

  mixins: [reusableMethodsMixin, asyncLoadMixin],
  components: {
    datePicker: VuePersianDatetimePicker,
    Multiselect,
  },
  data() {
    return {
      // validationErr:null,
      selectedPhoneTypes: [],
      counter: 1,
      phoneTypeCount: [],
      industrialParksItems: [],
      phoneTypeItems: [],
      checkbox: false,
      timer: null,
      handleMapSearch: null,
      mapSearchLoading: false,
      mapSearchItems: [],
      mapSearchValue: '',
      neighbourhood: null,
      formType: '1',
      stateId: '',
      cityId: '',
      provinceList: [],
      cityList: [],
      urbanareasList: [],
      merchantCategoryTypeItems: [],
      companyTypeGroupsList: [],
      registerTypeList: [],
      permittedSignerName: '',
      birthdateDay: '',
      birthdateMonth: '',
      birthdateYear: '',
      loaded: false,
      merchantMemberTypeItems: [],
      selectionItems: [],
      defaultOpenedTreeView: null,
      activeTreeItem: [],
      openTreeItem: [],
      zoom: 5,
      path: '/media/map/pin.svg',
      url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
      marker: [],
      center: { lat: 35.738018, lng: 51.404314 },
      merchantCategoriesList: [],
      merchantCategoryFields: [
        {
          value: 'mainCategoryTitle',
          text: 'نوع فعالیت',
          sortable: false,
        },
        // {
        //   value: 'categoryName',
        //   text: 'دسته فرایند',
        //   sortable: false,
        // },
        {
          value: 'breadcrumb',
          text: 'فرایند اصلی',
          sortable: false,
        },

        {
          value: 'actions',
          text: 'حذف',
          sortable: false,
        },
      ],
      merchantCategoryTypes: [],
      activeSelectedItem: null,
      searchTreeList: null,
      companyNameErrors: [],
      supplierProductCategoryTypes: [],
      hasIsManufacturerInQuery: false,
    };
  },

  computed: {
    ...mapGetters(['merchantBaseUrl', 'companyTypeGroups', 'neshanApiKey']),
    filteredMerchantMemberTypeItems() {
      return this.merchantMemberTypeItems.filter(
        (el) => el.title !== 'Manager'
      );
    },
    merchantCategoryTypeHint() {
      if (!this.hasIsManufacturerInQuery) {
        return 'ابتدا نوع فعالیت خود را انتخاب کنید';
      }
      return '';
    },
    form: {
      get() {
        return this.formData;
      },
      set(newValue) {
        this.$emit('update:formData', newValue);
      },
    },
    filteredMerchantCategoryTypeItems() {
      return this.merchantCategoryTypeItems.filter((el) =>
        this.supplierProductCategoryTypes.includes(el.title)
      );
    },
    categorySelectionLabel() {
      if (this.form.isManufacturer) {
        return ' انتخاب دسته بندی های خدمات و محصولات';
      }
      return 'انتخاب دسته بندی های کالا و تجهیزات صنعتی';
    },
  },
  watch: {
    'form.creatorPerson.birthdate': function () {
      console.log(this.form.creatorPerson.birthdate);
      if (
        this.form.creatorPerson.birthdate == null ||
        this.form.creatorPerson.birthdate.includes('0001-01-01')
      ) {
        var date = new Date();
        date.setFullYear(date.getFullYear() - 20);
        this.form.creatorPerson.birthdate = date
          .toJSON()
          .slice(0, 10)
          .replace(/ ' '/g, '-');
      }
    },
    'form.managerPerson.birthdate': function () {
      if (
        this.form.managerPerson.birthdate == null ||
        this.form.managerPerson.birthdate.includes('0001-01-01')
      ) {
        var date = new Date();
        date.setFullYear(date.getFullYear() - 20);
        this.form.managerPerson.birthdate = date
          .toJSON()
          .slice(0, 10)
          .replace(/ ' '/g, '-');
      }
    },
    selectedPhoneTypes() {
      let selectedPhoneObj = [];
      let index = [];
      this.phoneTypeItems.forEach((x, i) => {
        if (this.selectedPhoneTypes.includes(x.title)) {
          selectedPhoneObj.push(x);
          index.push(i);
        }
      });
      this.addPhoneType(selectedPhoneObj, index);
    },
    stateId() {
      if (this.stateId != null && this.stateId != '') {
        this.getIndustrialParksItems();
      }
    },
    mapSearchValue(val) {
      if (val) {
        this.form.address.latitude = val.location.y;
        this.form.address.longitude = val.location.x;
        let latlng = { lat: val.location.y, lng: val.location.x };
        this.marker = [];

        this.marker.push(latlng);
        this.$refs.myMap.mapObject.flyTo(latlng, 15);
      }
    },
    handleMapSearch(val) {
      let app = this;
      // Items have already been loaded
      if (this.mapSearchItems.length > 30) return;

      // Items have already been requested
      if (this.mapSearchLoading) return;

      if (!val) {
        this.mapSearchItems = [];
      }
      if (this.timer) {
        clearTimeout(this.timer);
        this.timer = null;
      }
      this.timer = setTimeout(() => {
        if (val.length > 1) {
          this.mapSearchLoading = true;
          this.mapSearchItems = [];
          fetch(
            `https://api.neshan.org/v1/search?term=${val}&lat=${app.center.lat}&lng=${app.center.lng}`,
            {
              headers: {
                'Api-Key': app.neshanApiKey,
              },
            }
          )
            .then((res) => res.json())
            .then((res) => {
              if (res.code && res.code > 400) alert(res.message);
              const { count, items } = res;
              this.mapSearchItems = [];
              this.mapSearchItems = items;
            })
            .catch((err) => {})
            .finally(() => (this.mapSearchLoading = false));
        }
      }, 1000);
    },
  },

  methods: {
    nationalCodeValidationErr() {
      this.validationErr = [];
    },
    currentLocationButton() {
      let app = this;
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition((position) => {
          app.marker = [];
          let latlng = {
            lat: position.coords.latitude,
            lng: position.coords.longitude,
          };

          app.form.address.latitude = position.coords.latitude;
          app.form.address.longitude = position.coords.longitude;
          app.marker.push(latlng);
          app.$refs.myMap.mapObject.flyTo(latlng, 15);
        });
      } else {
        alert('موقعیت یاب در این مرورگر پشتیبانی نمیشود');
      }
    },
    goToMarkPlace() {
      this.$refs.myMap.mapObject.flyTo(this.marker[0], 15);
    },
    leavePage() {
      // return "Write something clever here...";
      if (window.event) {
        //Internet Explorer
        alert('Browser back button is clicked on Internet Explorer...');
      } //Other browsers for example Chrome
      else {
        alert('Browser back button is clicked on other browser...');
      }
      // // alert('میخواهید صفحه را ترک کنید؟')
    },
    removePhoneType(item) {
      this.form.phones.forEach((x, i) => {
        if (x.type == item.type) {
          this.form.phones.splice(i, 1);
          this.phoneTypeItems.push({ title: x.type, displayName: x.title });
          this.selectedPhoneTypes.splice(
            this.selectedPhoneTypes.indexOf(item.type),
            1
          );
        }
      });
    },
    addPhoneType(obj, index) {
      this.counter += 1;
      obj.forEach((x) => {
        this.form.phones.push({
          title: x.displayName,
          type: x.title,
          phoneNumber: '',
        });
      });

      index.forEach((i) => {
        this.phoneTypeItems.splice(i, 1);
      });
    },
    centerUpdated(event) {
      this.center = event;
    },
    async addMerchantCompany() {
      // const clonedFormData = JSON.parse(JSON.stringify(this.form));
      const clonedFormData = this.form;
      this.pruneProperties(clonedFormData);

      const check = await this.$refs.obs.validate();
      if (!check) {
        let err = {
          response: { data: this.$refs.obs.errors, status: 400 },
          receive: 'front',
        };
        return Helper.handleErrors(err, this);
      }

      if (!clonedFormData.categoryIds.length) {
        return Swal.fire({
          icon: 'error',
          title: 'خطا',
          html: 'شما هیچ کسب و کاری انتخاب نکرده اید',
          confirmButtonText: ' بستن',
        });
      }
      if (clonedFormData.creatorIsManager) {
        clonedFormData.creatorPerson = null;
      }

      const loader = this.$loading.show();
      merchantCompanyRepository()
        .addMerchantCompany(clonedFormData, this.merchantBaseUrl, {
          MerchantId: this.merchantInformation.merchantId,
        })
        .then(() => {
          this.$router
            .push({
              path: `/merchant-companies/list`,
            })
            .then(() => {
              Swal.fire({
                icon: 'success',
                title: 'کسب و کار با موفقیت ثبت شد',
                confirmButtonText: ' بستن',
              });
            });
        })
        .catch((error) => {
          Helper.handleErrors(error, this);
        })
        .finally(() => loader.hide());
    },
    async checkValidName(event, name) {
      if (event.target.value == '') {
        this.companyNameErrors = [`${name} الزامی است`];
        return;
      }
      if (event.target.value.length < 3) {
        this.companyNameErrors = [`${name} حداقل بایستی 3 کاراکتر باشد`];
        return;
      }
      try {
        const params = {
          merchantName: event.target.value,
        };
        const response = await merchantRepository().forbidenNamesValidate(
          this.merchantBaseUrl,
          params
        );
        if (!response.data.isValid) {
          this.companyNameErrors = [response.data.message];
        } else {
          this.companyNameErrors = [];
        }
      } catch (error) {
        this.companyNameErrors = [];
      }
    },
    selectTree(val) {
      if (val && val.length) {
        this.getMerchantCategoriesByIds();
      } else {
        this.merchantCategoriesList = [];
        this.form.categoryIds = [];
      }
    },
    handleSearch(val) {
      if (val) {
        this.$refs.treeView.updateAll(true);
      } else {
        this.$refs.treeView.updateAll(false);
        this.activeSelectedItem.openTreeItem = this.defaultOpenedTreeView;
      }
    },
    handleFullScreenChange() {
      this.$refs.myMap.mapObject.panTo([
        this.form.address.latitude,
        this.form.address.longitude,
      ]);
    },
    selectNeighbourhood(val) {
      this.form.address.neighbourhoodId = val.id;
    },
    removeNeighbourhood() {
      this.form.address.neighbourhoodId = null;
    },
    label(obj) {
      return obj.name;
    },
    removeMerchantCategoriesList(item) {
      // step:1 remove from merchant categories list
      this.merchantCategoriesList = this.merchantCategoriesList.filter(
        (el) => el.categoryId !== item.categoryId
      );
      this.form.categoryIds = this.form.categoryIds.filter(
        (el) => el !== item.categoryId
      );
      // step:2 remove from selected tree items
      this.activeSelectedItem.activeTreeItem =
        this.activeSelectedItem.activeTreeItem.filter(
          (el) => el.id != item.categoryId
        );
      // step:3 remove from categoryTypes if removed merchant
      // category is not exist in categoryTypes
      const categoryTypeTitle = item.categoryTypeTitle;
      if (
        !this.merchantCategoriesList.find(
          (el) => el.categoryTypeTitle == categoryTypeTitle
        )
      ) {
        this.form.categoryTypes.splice(
          this.form.categoryTypes.indexOf(categoryTypeTitle),
          1
        );
        this.merchantCategoryTypes.splice(
          this.form.categoryTypes.indexOf(
            (el) => el.title == categoryTypeTitle
          ),
          1
        );
      }
    },
    scrollToElement(ref) {
      setTimeout(() => {
        const el = this.$refs[ref];
        if (el) {
          el.scrollIntoView({ behavior: 'smooth' });
        }
      }, 300);
    },
    addMarkerAddr(event) {
      this.form.address.latitude = event.latlng.lat;
      this.form.address.longitude = event.latlng.lng;
      this.marker = [];
      this.marker.push(event.latlng);
    },
    getCitys() {
      this.cityId = null;
      this.neighbourhood = null;
      this.urbanareasList = [];
      const params = {
        stateId: this.stateId,
        cityType: 'City',
      };
      merchantRepository()
        .getCitiesByState(this.merchantBaseUrl, params)
        .then((res) => {
          this.cityList = res.data;
          this.loaded = true;
        })
        .catch((err) => {
          Helper.handleErrors(err, this);
        });
    },
    getIndustrialParksItems() {
      let params = { stateId: this.stateId };
      industrialParksRepository()
        .getDataByCityId(this.merchantBaseUrl, {}, params)
        .then((res) => {
          this.industrialParksItems = res.data;
        })
        .catch((err) => {
          Helper.handleErrors(err, this);
        });
    },
    getUrbanareasByCity() {
      this.neighbourhood = null;
      this.urbanareasList = [];
      this.form.address.cityId = this.cityId;
      urbanAreasRepository()
        .filterUrbanAreasByCity(this.merchantBaseUrl, { cityId: this.cityId })
        .then((res) => {
          this.urbanareasList = res.data;
        })
        .catch((err) => {
          Helper.handleErrors(err, this);
        });
    },
    getCategoriesTreeList(val) {
      const loader = this.$loading.show();
      const param = {};

      // param.categoryTypes = val.map((el) => el.title);
      param.categoryTypes = val.title;

      categoryRepository()
        .getCategoriesList(this.$store.getters.productBaseUrl, param)
        .then((res) => {
          const data = {
            item: val,
            treeList: res.data,
            activeTreeItem: [],
            openTreeItem: res.data,
          };
          this.$set(this.selectionItems, this.selectionItems.length, data);
          this.activeSelectedItem = data;
          this.defaultOpenedTreeView = data.openTreeItem;
          loader.hide();
        })
        .catch((error) => {
          loader.hide();
          Helper.handleErrors(error, this);
        });
    },
    changeFormType() {
      this.getRegisterCompanyTypeItems();
      this.form.company.companyType = null;
    },
    getRegisterCompanyTypeItems() {
      return new Promise((resolve, reject) => {
        const params = {
          companyTypeGroupId: this.formType,
        };
        merchantRepository()
          .getCompanytypegroupItems(this.merchantBaseUrl, params)
          .then(({ data }) => {
            this.registerTypeList = data;
            resolve();
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    changeSupplierProductCategoryTypes() {
      this.merchantCategoryTypes = [];
      this.activeSelectedItem = null;
      this.getSupplierProductCategoryTypes();
    },
    getSupplierProductCategoryTypes() {
      return new Promise((resolve, reject) => {
        const params = {
          supplierIsManufacturer: this.form.isManufacturer,
        };
        supplierProductRepository()
          .getSupplierProductCategoryTypes(
            this.$store.getters.productBaseUrl,
            params
          )
          .then(({ data }) => {
            this.supplierProductCategoryTypes = data;
            resolve();
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    getCategoryTypeItems() {
      return new Promise((resolve, reject) => {
        enumsRepository()
          .getEnum('CategoryTypeItems', this.$store.getters.productBaseUrl)
          .then(({ data }) => {
            this.merchantCategoryTypeItems = data;
            resolve();
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    getPhoneType() {
      return new Promise((resolve, reject) => {
        enumsRepository()
          .getEnum('PhoneType', this.$store.getters.merchantBaseUrl)
          .then(({ data }) => {
            this.phoneTypeItems = data.filter(
              (x) => x.title != 'Work' && x.title != 'Mobile'
            );

            resolve();
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    getProvinceList() {
      return new Promise((resolve, reject) => {
        merchantRepository()
          .getProvince(this.merchantBaseUrl)
          .then((res) => {
            this.provinceList = res.data;
            resolve();
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    getCompanyTypeGroups() {
      return new Promise((resolve, reject) => {
        this.$store
          .dispatch('getCompanyTypeGroups')
          .then(() => {
            resolve();
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    getMerchantCategoriesByIds() {
      const ids = this.activeSelectedItem.activeTreeItem.map((el) => {
        return el.id;
      });
      if (
        this.form.categoryIds == undefined ||
        this.form.categoryIds == null ||
        this.form.categoryIds == ''
      ) {
        this.form.categoryIds = [];
      }

      // this.form.categoryIds = ids;
      console.log(this.form.categoryIds);
      this.form.categoryIds = this.form.categoryIds.concat(ids);
      this.form.categoryIds = Array.from(new Set(this.form.categoryIds));
      const params = {
        ids: this.form.categoryIds.join(','),
        // ids: this.form.categoryIds,
      };
      categoryRepository()
        .getMerchantCategoriesByIds(this.$store.getters.productBaseUrl, params)
        .then((res) => {
          let ids = [];
          // this.merchantCategoriesList = res.data;
          this.merchantCategoriesList.forEach((x) => {
            ids.push(x.categoryId);
          });
          res.data.forEach((x) => {
            if (!ids.includes(x.categoryId)) {
              this.merchantCategoriesList.push(x);
            }
          });
          // this.merchantCategoriesList.push(res.data);
          // this.scrollToElement('tables');
          this.activeSelectedItem.activeTreeItem.forEach((el) => {
            if (!this.form.categoryTypes.includes(el.categoryType)) {
              this.form.categoryTypes.push(el.categoryType);
            }
          });
          // this.deSelectTree();
        });
    },
    deSelectTree() {
      this.selectionItems.forEach((element) => {
        element.activeTreeItem = [];
      });
    },
    getMerchantMemberTypeItems() {
      return new Promise((resolve, reject) => {
        enumsRepository()
          .getEnum('MerchantMemberType', this.merchantBaseUrl)
          .then(({ data }) => {
            this.merchantMemberTypeItems = data;
            resolve();
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    asyncUrbanAreas(query) {
      if (query && query.length >= 2) {
        const params = {
          cityId: this.cityId,
          key: query,
        };
        urbanAreasRepository()
          .filterUrbanAreasByCity(this.merchantBaseUrl, params)
          .then((res) => {
            this.urbanareasList = res.data;
          })
          .catch((error) => {
            Helper.handleErrors(error, this);
          });
      }
    },

    getData() {
      Promise.all([
        this.getCompanyTypeGroups(),
        this.getProvinceList(),
        this.getCategoryTypeItems(),
        this.getMerchantMemberTypeItems(),
        this.getRegisterCompanyTypeItems(),
      ])
        .then(() => {
          if (this.form.address.latitude && this.form.address.longitude) {
            this.marker.push({
              lat: this.form.address.latitude,
              lng: this.form.address.longitude,
            });
            this.center = [
              this.form.address.latitude,
              this.form.address.longitude,
            ];
            this.zoom = 16;
          }
          this.$refs.myMap.mapObject.panTo(this.center);
        })
        .catch((error) => {
          Helper.handleErrors(error, this);
        });
    },
  },
  mounted() {
    this.getData();
    if (this.form.isManufacturer !== null) {
      this.getSupplierProductCategoryTypes();
      this.hasIsManufacturerInQuery = true;
    }
    this.getPhoneType();
  },
};
</script>
p
<style lang="scss" scoped>
#currentLocationButton {
  position: absolute;
  bottom: 65px;
  left: 20px;
  padding: 10px;
  z-index: 400;
}
#refreshButton {
  position: absolute;
  bottom: 20px;
  left: 20px;
  padding: 10px;
  z-index: 400;
}
.ddd {
  width: 200px;
  height: 200px;
}
.fieldset-title {
  font-weight: 500;
  font-size: 20px;
  line-height: 33px;
  color: #006298;
  text-shadow: 0px 4px 4px rgb(0 0 0 / 25%);
}
.v-treeview {
  height: 200px;
  overflow: scroll;
}
.v-card__title {
  letter-spacing: 0 !important;
}
.multiselect {
  * {
    font-size: 1rem !important;
  }
  .theme--dark & {
    * {
      background: #1e1e1e;
      color: #ffffff;
    }
  }
}
.f-s-13 {
  font-size: 13px;
}
</style>
